import type { StageGroup } from './dashboard.models';

export const dashboardQueryKeys = {
  availability: (workspaceId: string) => ['dashboard', 'availability', { workspaceId }] as const,
  cropStagesCatalog: (language: 'en' | 'pt-BR') => ['crop-stages-catalog', { language }] as const,
  cropSummariesAll: () => ['dashboard', 'crop-summaries'] as const,
  cropSummaries: (workspaceId: string, referenceDate: string) =>
    ['dashboard', 'crop-summaries', { workspaceId, referenceDate }] as const,
  farmDetails: (workspaceId: string, rowId: string | null, referenceDate: string) =>
    ['dashboard', 'farm-details', { workspaceId, rowId, referenceDate }] as const,
};

export const dashboardMutationKeys = {
  riskFlag: (workspaceId: string, rowId: string) =>
    ['dashboard', 'risk-flag', { workspaceId, rowId }] as const,
};

export const CROP_SUMMARIES_STALE_TIME = 15 * 60 * 1000;

export const CROP_SUMMARIES_PAGE_SIZE = 1000;

export const AVAILABILITY_MONTHS = 3;

// Fractions of imaged farms; LaunchDarkly overrides them.
export const DEFAULT_LOW_COVERAGE_THRESHOLD = 0.5;
export const DEFAULT_HIGH_COVERAGE_THRESHOLD = 0.8;

export const RESIDUAL_STAGE_GROUPS: readonly StageGroup[] = ['bare_soil', 'unreadable', 'no_band'];

export const UNASSIGNED_CROP_ID = 'unassigned';
